
import { dts_ctx_resume_ok } from "./stores.js"

import { RingBuffer } from "ringbuf.js";
import dtsAwpURL from 'omt:./dts-awp.js';

const MAX_CHANNELS = 2;
const SAMPLE_RATE = 48000;
const RING_BUFFER_CAPACITY = SAMPLE_RATE * MAX_CHANNELS * 2; // 2s stereo

export const DTSInterface = {

    audioContext: null,
    awpNode: null,

    mic_id: null,   
    camera_id: null,
    mediaStreamSource: null,
    channels: 2,

    async initAudioContext(channels = 2) {
        this.channels = channels;
        await this._startAudioContext(channels);
    },


    updateMediaStreamSource(updated_stream, base_tracks){

        console.assert(this.audioContext)
        console.assert(this.awpNode);

        const new_id = base_tracks.audio?.id;
        if (!new_id || new_id === this.mic_id)
            return;

        if (this.mediaStreamSource) {
            this.mediaStreamSource.disconnect();
            this.mediaStreamSource = null;
        }

        this.mediaStreamSource = this.audioContext.createMediaStreamSource(updated_stream);
        this.mediaStreamSource.channelCountMode = 'explicit';
        this.mediaStreamSource.channelCount = this.channels;
        this.mediaStreamSource.connect(this.awpNode);

        this.mic_id = new_id;
    },

    updateCameraTrack(camera_track){


    },

    resumeAudioContextFirstTime(self_type){
        
        if (self_type !== "talent"){
            dts_ctx_resume_ok.set(true);
            return;
        }

        console.assert(this.audioContext);

        this.audioContext?.resume().then(() => {
            dts_ctx_resume_ok.set(true);
            console.log("[PL-DTS] New DTS Audio Context State: ", this.audioContext.state);
        });
    },

    async _startAudioContext(channels = 2){

        this.audioContext = new AudioContext({ sampleRate: SAMPLE_RATE, latencyHint: 'interactive' });

        if (this.audioContext.sampleRate !== SAMPLE_RATE) {
            console.error(`[DTSInterface] AudioContext sample rate is ${this.audioContext.sampleRate}, required ${SAMPLE_RATE}`);
            await this._cleanup();
            return null;
        }

        await this.audioContext.audioWorklet.addModule(dtsAwpURL);

        const audio_sab = RingBuffer.getStorageForCapacity(RING_BUFFER_CAPACITY, Float32Array);
        const notify_sab = new SharedArrayBuffer(4);

        this.awpNode = new AudioWorkletNode(this.audioContext, 'dts-awp', {
            numberOfInputs: 1,
            numberOfOutputs: 0,
            channelCount: channels,
            channelCountMode: 'explicit',
            processorOptions: { audio_sab, notify_sab, channels: channels },
        });
    },

    async _cleanup() {  
        
        if (this.audioSource) {
            this.audioSource.disconnect();
            this.audioSource = null;
        }

        if (this.audioContext) {
            await this.audioContext.close();
            this.audioContext = null;
        }

        this.awpNode = null;        
    },

}


  // -- {[type]: {id: id}} where type is "microphone" or "camera"
    // async startOrUpddateStream(request, channels = 2){

    //     console.assert(this.audioContext);
    //     console.assert(this.awpNode);
        
    //     const camera_id = request.camera?.id;
    //     const mic_id = request.microphone?.id;

    //     if (!camera_id && !mic_id){
    //         console.warn("[PL-DTS] Empty request object");
    //         return;
    //     }
    //     if (mic_id === this.mic_id && camera_id === this.camera_id)
    //         return;

    //     let new_stream = await Default_GUM.call(navigator.mediaDevices, {
    //         audio: mic_id ? {
    //             deviceId: { exact: mic_id },
    //             channelCount: { ideal: channels },
    //             sampleRate: { ideal: SAMPLE_RATE },
    //             noiseSuppression: false,
    //             autoGainControl: false,
    //             echoCancellation: false,
    //         } : false,
    //         video: camera_id ? {
    //             deviceId: { exact: camera_id },
    //         } : false,
    //     }).catch(e => {
    //         console.error('[DTSInterface] GUM failed:', e);
    //         return null;
    //     });

    //     // -- maybe stop and remove old mic track
    //     if (camera_id){
    //         this.stream && this._replaceTrack(new_stream, "camera");
    //         this.camera_id = camera_id;
    //     }
        
    //     if (mic_id){
            
    //         this.stream && this._replaceTrack(new_stream, "mic");
            
    //         if (this.mediaStreamSource) {
    //             this.mediaStreamSource.disconnect();
    //             this.mediaStreamSource = null;
    //         }

    //         this.mediaStreamSource = this.audioContext.createMediaStreamSource(new_stream);
    //         this.mediaStreamSource.channelCountMode = 'explicit';
    //         this.mediaStreamSource.channelCount = channels;
    //         this.mediaStreamSource.connect(this.awpNode);

    //         this.mic_id = mic_id;

    //     }

    //     if (!this.stream)
    //         this.stream = new_stream;

    //     console.log(this.stream.getTracks());
    // },

     // _replaceTrack(new_stream, type){

    //     const old_track = type === "mic" ? this.stream?.getAudioTracks()[0] : this.stream?.getVideoTracks()[0]; 
    //     if (old_track){
    //         old_track.stop();
    //         this.stream.removeTrack(old_track);
    //         console.log("[PL-DTS] Removed old track: ", old_track);
    //     }

    //     const new_track = type === "mic" ? new_stream.getAudioTracks()[0] : new_stream.getVideoTracks()[0]; 
    //     if (new_track) {
    //         console.log("[PL-DTS] Added New Track: ", new_track);
    //         this.stream.addTrack(new_track);
    //     }
    // },
